import { defineComponent } from "vue";

import { COMPONENT_NAME } from "./attributes";

import { DefaultHeader } from "../header";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    DefaultHeader,
  },
  computed: {
    isViewShow(): boolean {
      const user = this.$projectServices.userRepo;
      return (
        !!user.userInfo.id &&
        (!user.isVerified ||
          !!user.userInfo.user_info.user_agreement ||
          this.$route.name === "settings")
      );
    },
  },
});
